// extracted by mini-css-extract-plugin
module.exports = {"inputBox":"SearchInput_inputBox__QKY8m","input":"SearchInput_input__qZX2V","clear":"SearchInput_clear__Hpm9e"};